import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar";

const Layout = () => {
  useEffect(() => {
    document.title = "Visual Content Assessment Tool";
  }, []);
  return (
    <>
      <Navbar key={window.location.pathname} />
      <Outlet />
    </>
  );
};

export default Layout;
